var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-a46adada]{width:100%;margin:0 auto}.bodyLogin[data-v-a46adada]{background:url(" + escape(require("../assets/fundo2.jpg")) + ") no-repeat}.headerLogin[data-v-a46adada]{padding:30px;color:#fff;font-size:2em;font-weight:400}.headerLogin text-transform uppercase[data-v-a46adada]{text-align:center}.v-card[data-v-a46adada]{box-shadow:0 0 9px #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a46adada","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CriarConta_OLD.vue
// module id = 1037
// module chunks = 0